module.exports = __webpack_public_path__ + "static/saskatchewan-b502d64421c485304c9328524cf2302e.png";